import { SvgIcon, type SvgIconProps } from "@mui/material";

/**
 * Eye control for opening the screen-location preview.
 * Stroke style and color token align with
 * [Future Designs — Icon / Two Tone / Eye](https://www.figma.com/design/WaTHJQV96FYmvZfV4w63Zm/Future-Designs?node-id=8291-114091&m=dev)
 * (Daybreak Blue / blue-6 `#1890FF` when the parent sets `color`).
 */
const ScreenLocationPreviewEyeIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 24 24" fontSize="small" {...props}>
		<path
			fill="none"
			stroke="currentColor"
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
		/>
		<path
			fill="none"
			stroke="currentColor"
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
		/>
	</SvgIcon>
);

export default ScreenLocationPreviewEyeIcon;
